/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Businessemail1Inputs */

const de__field_businessemail1 = /** @type {(inputs: _Field_Businessemail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail (dienstlich)`)
};

/**

* @param {_Field_Businessemail1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_businessemail1 = /** @type {((inputs?: _Field_Businessemail1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Businessemail1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_businessemail1(inputs)
});
export { _field_businessemail1 as "_field_businessEmail" }